<template>
<div>
    <div class="col-12 nopads d-flex justify-content-between align-items-center pb-1 pt-1">
        <div class="flex-grow-1">
            <h4 class="form-header pointer hover-header" @click.stop="commentsVisible = !commentsVisible">{{ $t('comments.title') }} ({{comments.length}})</h4>
        </div>
        <div class="ms-2 px-2" @click.stop="commentsVisible = !commentsVisible">
            <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" v-bind:class="{ rotated: commentsVisible }"/>
        </div>
    </div>
    <div class="item-details" :class="{ collapsed: commentsVisible, 'comment-collapse': !commentsVisible, 'routa-collapse': commentsVisible }">
        <span class="pt-1 pb-1" v-if="comments.length < 1" style="color: #BCBCBC; font-style: italic">{{ $t('comments.no_comments')}}</span>
        <!-- Show last comment in preview -->
        <div v-if="comments.length > 0 && !commentsVisible" class="preview-container">
            <comment :comment="comments[comments.length-1]" :user="user"/>
            <div v-if="!commentsVisible" class="preview-overlay d-flex justify-content-end" style="padding-top: 2.75em; padding-right: .5em">
                <span class="pointer link" style="font-size: .9em" @click.stop="commentsVisible = true">{{ $t('common.show_more')}}</span>
            </div>
        </div>
        <!-- Show all comments -->
        <div v-else ref="commentList" style="max-height: 30em; overflow-y: auto; overflow-x: hidden">
            <comment
                v-for="(comment, index) in comments"
                v-bind:key="comment.id"
                :comment="comment"
                :user="user"
                :ref="index === comments.length - 1 ? 'lastComment' : null"
            />
        </div>
    </div>
    <div v-if="commentsVisible">
        <comment-editor
            v-if="commentsVisible"
            :user="user"
            :topic="topic"
            :id="id"
            :custom-api-url="customApiUrl"
            :type="type"
            @commentAdded="fetchComments"/>
    </div>
    <div
        v-if="loading"
        id="loader"
        class="spinner"
    />
</div>

</template>


<script>
import {restApi} from '../mixins/RestApiMixin'
import Comment from "@/components/comments/Comment";
import CommentEditor from "@/components/comments/CommentEditor";

export default {
    name: 'CommentContainer',
    components: {CommentEditor, Comment},
    mixins: [restApi],
    data: function () {
        return {
            commentsVisible: false,
            commentsFetched: false,
            comments: [],
            loading: false
        }
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        topic: {
            type: Number,
            required: true
        },
        id: {
            type: Number,
            required: true
        },
        type: {
            type: Number,
            required: false
        },
        customApiUrl: {
            type: String,
            required: false,
            default: null
        }
    },

    watch: {
        commentsVisible(val) {
            if (val) {
                this.scrollToBottom()
            }
        }
    },

    mounted() {
        this.fetchComments()
    },

    methods: {

        fetchComments() {
            this.loading = true
            this.restFetchParams(this.customApiUrl ? this.customApiUrl : this.commentUrl, {topic: this.topic, type: this.type, record_id: this.id},
                this.fetchSuccess, this.fetchFail)
        },

        fetchSuccess(response){
            this.loading = false
            this.commentsFetched = true
            if (response && response.data) {
                this.comments = response.data
                this.scrollToBottom()
                this.$emit('commentsReady')
            }
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const el = this.$refs.commentList
                if (el) {
                    el.scrollTop = el.scrollHeight
                }
            })
        },

        fetchFail() {
            this.loading = false
        },

        getPhotos() {
            let results = []
            if (this.comments) {
                this.comments.forEach(comment => {
                    if (comment.photo) {
                        results.push(comment.photo)
                    }
                })
            }
            return results
        }

    }
}
</script>
<style>

.preview-container {
    position: relative;
    overflow: hidden;
    height: 5.5em;
}


.preview-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%; /* Adjust as needed */
    background: linear-gradient(to top, white 20%, rgba(255, 255, 255, 0) 100%);
}

</style>
